import IconHOC from 'shared/legacy/icons/v2/IconHOC';
import { ReactComponent as ZapIcon } from './zap.svg';

export const Zap = IconHOC(ZapIcon);
